<template>
  <el-dialog
      v-model="dialogVisible"
      :title="formData.ID?'编辑队员':'新增队员'"
      height="340px"
      width="800px"
      :close-on-click-modal="false"
      :append-to-body="true"
      :show-close="true"
      :before-close="handleClose">
    <div class="dialog-item1">
      <el-form :model="formData"
               label-width="auto"
               :rules="rules"
               class="el-form-box" ref="ruleFormRef">
        <el-row :gutter="10">
          <el-col :span="12" >
            <el-form-item label="队员姓名：" prop="Name">
              <el-input v-model.trim="formData.Name" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="队内排名："  prop="TeamOrder" >
              <el-select v-model="formData.TeamOrder" :disabled="formData.isMainRole">
                <el-option v-for="i of RANKSTUDENTLIMITED" :key="i" :value="i" :label="i" :disabled="i===1"/>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="证件号码：" prop="CardId" >
              <el-input type="text" v-model="formData.CardId" >
                <template #prepend>
                  <el-select v-model="formData.DocumentType" placeholder="证件" style="width: 90px">
                    <el-option v-for="item of DOCUMENTTYPES" :key="item.ID" :value="item.ID" :label="item.Name"/>
                  </el-select>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别：" prop="Sex" >
              <el-select v-model="formData.Sex">
                <el-option v-for="item of SEXS" :key="item.ID" :value="item.ID" :label="item.Name"/>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="手机号：" prop="Phone" >
              <el-input v-model="formData.Phone" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮箱：" prop="Email" >
              <el-input v-model="formData.Email" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学院：" prop="Collage" >
              <el-input v-model="formData.Collage"  placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="专业："   prop="Major"  >
              <el-input v-model="formData.Major" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学号："   prop="StudentId"  >
              <el-input v-model="formData.StudentId" placeholder="请输入"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学生类型："   prop="Type"  >
              <el-select v-model="formData.Type">
                <el-option v-for="item of STUDENTTYPE" :key="item.ID" :value="item.ID" :label="item.Name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="入学年份："   prop="EnrollYear"  >
              <el-select v-model="formData.EnrollYear">
                <el-option v-for="item of EnrollYears" :key="item.ID" :value="item.ID" :label="item.Name"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年级："   prop="Grade"  >
              <el-select v-model="formData.Grade">
                <el-option v-for="item of GRADE" :key="item.ID" :value="item.ID" :label="item.Name"/>
              </el-select>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">-->
<!--            <el-form-item label="设为队长：" prop="isActive" >-->
<!--              <el-switch-->
<!--                  v-model="formData.isMainRole"-->
<!--                  class="ml-2"-->
<!--                  inline-prompt-->
<!--                  style="&#45;&#45;el-switch-on-color: #3f9cfd; &#45;&#45;el-switch-off-color: #ff4949"-->
<!--                  active-text="是"-->
<!--                  inactive-text="否"-->
<!--              />-->
<!--            </el-form-item>-->
<!--          </el-col>-->

        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="save(ruleFormRef)"
                   :loading = "loading"
        >确定</el-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
import {ref, defineProps, defineEmits, reactive,onMounted} from 'vue';
import {ElMessage} from "element-plus";
import {validateForm,validateCardId} from "@/utils/formValidate";
import {addMember, updateMember} from "@/api/student";
import {
  SEXS,
  STUDENTTYPE,
  GRADE,
  RANKSTUDENTLIMITED,
  DOCUMENTTYPES,
  getYearsList
} from "@/utils/commonSetting"
const emits = defineEmits(['close', 'success'])
const dialogVisible = ref(true)
const ruleFormRef = ref()
const EnrollYears = getYearsList(10)
var formData = reactive({
  ID:null,
  Name: null, // 队员姓名
  TeamOrder:null,// 队内排名
  CardId:null, // 身份证号
  Sex:null,// 部门
  Phone:null,
  Email:null,
  Collage:null,//学院
  Major: null,// 专业
  StudentId: null,// 学号
  Type: null,// 学生类型
  Grade:null, // 年级
  Role:null, // 1.队长，2队员,默认注册的是队长，创建后的是队员
  isMainRole:false,
  EnrollYear:null, //入学年份 int
  DocumentType:"1"
})
const loading = ref(false)

// 验证
const validateCard = (rule, value, callback)=>{
  if (!value || !value.trim()) {
    callback(new Error('请输入证件号'))
  }else{
    const v = validateCardId(formData.DocumentType,value)
    if(v){
      callback()
    }else{
      if(formData.DocumentType==1){
        callback(new Error("请输入正确的身份证号"))
      }else{
        callback(new Error("请输入正确的护照号"))
      }

    }
  }

}
const rules = ({
  Name: [{required: true, message: '请输入队员姓名', trigger: ['change', 'blur']}],
  TeamOrder: [{required: true, message: '请设置队内排名', trigger: ['change', 'blur']}],
  CardId: [
    {required: true, message: '请输入证件号码', trigger: ['change', 'blur']},
    {validator: validateCard, trigger: ['blur']}
  ],
  Sex: [{required: true, message: '请选择性别', trigger: ['change', 'blur']}],
  Phone: [
    {required: true, message: '请输入手机号', trigger: ['change', 'blur']},
    {pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: ['blur']}
  ],
  Email: [
    {required: true, message: '请输入邮箱', trigger: ['change', 'blur']},
    {pattern: /^[a-zA-Z0-9_.]+@[a-zA-Z0-9-]+[.a-zA-Z]+$/, message: '请输入正确的邮箱', trigger: ['blur']}
  ],
  Collage: [{required: true, message: '请输入学院', trigger: ['change', 'blur']}],
  Major: [{required: true, message: '请输入专业', trigger: ['change', 'blur']}],
  StudentId: [{required: true, message: '请输入学号', trigger: ['change', 'blur']}],
  Type: [{required: true, message: '请选择学生类型', trigger: ['change', 'blur']}],
  Contact: [{required: true, message: '请输入姓名', trigger: ['change', 'blur']}],
  Grade: [{required: true, message: '请选择年级', trigger: ['change', 'blur']}],
  EnrollYear: [{required: true, message: '请选择入学年份', trigger: ['change', 'blur']}],
})

const props = defineProps({
  item: {
    default: {},
  },
  numbers:{
    default:5
  }
})
// 开始
onMounted(()=>{
  if(props.item && props.item.ID){
    formData.ID = props.item.ID
    formData.Name = props.item.Name
    formData.TeamOrder = props.item.TeamOrder
    formData.CardId = props.item.CardId
    formData.Sex = props.item.Sex?props.item.Sex:null
    formData.Phone = props.item.Phone
    formData.Email = props.item.Email
    formData.Collage = props.item.Collage
    formData.Major = props.item.Major
    formData.StudentId = props.item.StudentId
    formData.Type = props.item.Type
    formData.Grade = props.item.Grade?props.item.Grade:null
    formData.Role = props.item.Role
    formData.isMainRole = props.item.Role==1
    formData.EnrollYear = props.item.EnrollYear?props.item.EnrollYear:null
    formData.DocumentType= props.item.DocumentType?props.item.DocumentType:"1"
  }
})


const handleClose = () => {
  dialogVisible.value = false
  emits("close", true)
}
// 保存
const save = async (ruleFormRef) => {
  const isvalidate =await validateForm(ruleFormRef)
  if(!isvalidate){
    return
  }
  loading.value = true
  let res,messPre;
  const params = {
    ...formData,
    Role:formData.isMainRole?1:2,
  }
  if( formData.ID){
    res = await updateMember(params)
    messPre = '修改'
  }else{
    res = await addMember(params)
    messPre = '创建'
  }
  loading.value = false
  if(res.err_code===0){
    ElMessage.success(messPre + "成功")
    emits("success", true)
  }else{
    ElMessage.warning(res.err_msg || messPre + "失败")
  }

}
</script>

<style scoped>
.dialog-item1 {
  width: 100%;
  height: 340px;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
